import styled from "styled-components";

export const Container = styled.div`
display: flex;
align-items: center;
justify-content: start;
padding: 15px 20px;
cursor: pointer;

&:hover {
    background-color: #f0f2f5;
}

svg {
    width: 40px;
    height: 40px;
    background-color: #ccc;
    border-radius: 50%;
    margin-right: 20px;
    min-width: fit-content;
}

&:active {
    background-color: #f0f2f5;
}
`;

export const Name = styled.span`
font-size: 15px;
font-weight: 500;
overflow: hidden;
text-overflow: ellipsis;
`;
 

export const Avatar = styled.img`
width: 40px;
height: 40px;
border-radius: 50%;
margin-right: 20px;
min-width: fit-content;
`;